import { render, staticRenderFns } from "./BulkDelete.vue?vue&type=template&id=fd9b9a70&scoped=true"
import script from "./BulkDelete.vue?vue&type=script&lang=js"
export * from "./BulkDelete.vue?vue&type=script&lang=js"
import style0 from "./BulkDelete.vue?vue&type=style&index=0&id=fd9b9a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9b9a70",
  null
  
)

export default component.exports